import { useState, useEffect } from "react";
import { hooksService } from "../services/asistenciaHooks.service";
import { useSelector } from "react-redux";
import Cookies from "universal-cookie";

export const useNiveles = (initialState = [], idSede) => {
    const cookies = new Cookies()
    const urlState = useSelector(state => state.url.urlSchoolApi)
    const { headersAPI: headers } = useSelector(state => state.url)
    const url = urlState === '' || urlState === undefined || urlState === null ? cookies.get("__urlSchoolApi") : urlState
    const [ niveles, setNiveles ] = useState(initialState)
    const objeto = {
        opcion: "NIVELES",
        Idsede: idSede,
      }
      const getData = async () => {
        const response = await hooksService(url, headers, objeto)
        setNiveles(response)
      }
      useEffect(() => {
        getData();
      }, [idSede])

      return [ niveles, setNiveles ]
}